import R from 'ramda';

export const createOrganizationSchema = ({
  currentUrl,
  name,
  logo,
  fallbackUrl,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name,
  url: currentUrl || fallbackUrl,
  logo,
});

export const createFaqSchema = ({ tabs }) => {
  const mainEntity = R.pipe(
    R.defaultTo([]),
    R.chain((tab) => R.defaultTo([], R.prop('accordion', tab))),
    R.map((item) => ({
      '@type': 'Question',
      name: R.propOr('', 'heading', item),
      acceptedAnswer: {
        '@type': 'Answer',
        text: R.propOr('', 'introduction', item),
      },
    })),
    R.filter(
      (item) =>
        R.path(['name'], item) && R.path(['acceptedAnswer', 'text'], item)
    )
  )(tabs);

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };
};

export const createArticleSchema = ({
  headline,
  description,
  imageUrl,
  url,
  datePublished,
  publisher,
}) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
  };

  if (description) {
    schema.description = description;
  }
  if (imageUrl) {
    schema.image = imageUrl;
  }
  if (url) {
    schema.mainEntityOfPage = {
      '@type': 'WebPage',
      '@id': url,
    };
  }
  if (datePublished) {
    schema.datePublished = datePublished;
  }
  if (publisher && publisher.name) {
    schema.publisher = {
      '@type': 'Organization',
      name: publisher.name,
    };
    if (publisher.logo) {
      schema.publisher.logo = {
        '@type': 'ImageObject',
        url: publisher.logo,
      };
    }
  }

  return schema;
};

export const createWebPageSchema = ({ url, name, description }) => {
  if (!url) {
    return null;
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': url,
    url,
  };

  if (name) {
    schema.name = name;
  }
  if (description) {
    schema.description = description;
  }

  return schema;
};

export const resolveCustomSchema = ({ customSchema, fallbackSchema }) => {
  if (!customSchema) {
    return fallbackSchema;
  }

  try {
    return typeof customSchema === 'string'
      ? JSON.parse(customSchema)
      : customSchema;
  } catch (e) {
    return fallbackSchema;
  }
};
